import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export function ProtectedAdminRoute() {
  const { isAuthenticated, isAdmin, isLoading, hasAcceptedCurrentTerms } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!hasAcceptedCurrentTerms) {
    return <Navigate to="/agreement" replace />
  }

  if (!isAdmin) {
    return <Navigate to="/overview" replace />
  }

  return <Outlet />
}
